import { RepositoryBase } from '@app/repositories/RepositoryBase';

export class StressAreaTypeRepository<StressAreaTypeModel> extends RepositoryBase<StressAreaTypeModel> {
    public constructor() {
        super('stressAreaType');
    }
}
